/**
 * "Waking up the server…" (2.7, plan E3 + G3). On Render's free plan the server sleeps after 15 quiet minutes and the
 * next visitor waits about 50 seconds. If the server hasn't answered within a moment, this shows a calm screen with a
 * progress bar instead of a blank page, keeps asking, and gets out of the way the moment the server answers. If it
 * never answers, it says so plainly with a Retry button: never a blank page.
 */
const WAKE_GRACE_MS = 1500;      // a normal answer comes long before this
const WAKE_EXPECT_MS = 55000;    // a cold start on Render's free plan
const WAKE_GIVE_UP_MS = 120000;

function wakeOverlay() {
  const el = document.createElement("div");
  el.id = "ges-wake";
  el.className = "wake";
  el.setAttribute("role", "status");
  el.innerHTML = `<div class="wake-card">
      <div class="wake-logo" aria-hidden="true">GES</div>
      <h2>Waking up the server…</h2>
      <p>The game's server naps when nobody is playing. It takes up to a minute to wake; your game is safe.</p>
      <div class="wake-bar" aria-hidden="true"><i></i></div>
      <p class="wake-note">Waited <b data-wake-s>0</b> s</p>
    </div>`;
  document.body.appendChild(el);
  return el;
}

async function wakePing(timeout) {
  const ctl = typeof AbortController === "function" ? new AbortController() : null;
  const timer = setTimeout(() => ctl && ctl.abort(), timeout);
  try {
    const r = await fetch(`/api/health?t=${Date.now()}`, { cache: "no-store", signal: ctl ? ctl.signal : undefined });
    return r.ok;
  } catch (e) {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

async function wakeWatch() {
  const t0 = Date.now();
  let overlay = null, tick = 0;
  const first = wakePing(WAKE_GIVE_UP_MS);
  const quick = await Promise.race([first, new Promise((r) => setTimeout(() => r("slow"), WAKE_GRACE_MS))]);
  if (quick === true) return;  // awake: nothing to show
  overlay = wakeOverlay();
  const bar = overlay.querySelector(".wake-bar i"), secs = overlay.querySelector("[data-wake-s]");
  tick = setInterval(() => {
    const ms = Date.now() - t0;
    bar.style.width = `${Math.min(95, (100 * ms) / WAKE_EXPECT_MS).toFixed(1)}%`; // eases to 95% until it answers
    secs.textContent = String(Math.round(ms / 1000));
  }, 250);
  let ok = quick === true || (await first);
  while (!ok && Date.now() - t0 < WAKE_GIVE_UP_MS) {
    ok = await wakePing(10000);
    if (!ok) await new Promise((r) => setTimeout(r, 2000));
  }
  clearInterval(tick);
  if (ok) {
    bar.style.width = "100%";
    overlay.classList.add("done");
    setTimeout(() => overlay.remove(), 450);
    if (typeof window.refreshAll === "function" && !document.getElementById("dashboard-screen")?.classList.contains("hidden")) window.refreshAll();
    return;
  }
  overlay.querySelector(".wake-card").innerHTML = `<div class="wake-logo" aria-hidden="true">GES</div>
    <h2>The server isn't answering</h2>
    <p>It may be restarting, or your connection dropped. Nothing you've done is lost: try again in a minute.</p>
    <button type="button" class="primary" data-wake-retry>Try again</button>`;
  overlay.querySelector("[data-wake-retry]").addEventListener("click", () => location.reload());
}

const wakeInTests = typeof navigator !== "undefined" && /jsdom|node/i.test(navigator.userAgent || "");
if (typeof window !== "undefined" && typeof document !== "undefined" && typeof fetch === "function" && !wakeInTests
    && /^https?:$/.test((window.location || {}).protocol || "")) {
  const go = () => { wakeWatch().catch(() => { /* a helper must never break the game */ }); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", go);
  else go();
}

export { wakeWatch };
